// extracted by mini-css-extract-plugin
export var label = "_4v-1";
export var reminder = "_4v-0";